import { usePathMatchIndex } from '@features/auth/hooks';
import { AuthStepper } from '@features/auth/registration/components/Common/AuthStepper';

const steps = ['crop-selection', 'additional-information'];

export function CropCreationLayout() {
	const activeStepIndex = usePathMatchIndex(steps);

	return <AuthStepper hFull activeStepIndex={activeStepIndex} steps={steps} />;
}
